module.exports = __webpack_public_path__ + "static/feature-money-5a39fcb1faecdbfdc4c89e8c9744d9bb.svg";